<div class="login-layout">
    <div class="login-left-pannel">
        <app-login-form></app-login-form>
    </div>
    <div class="login-right-pannel"></div>
</div>